module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc12",
      "id": "dd12"
    }
  }, [_c('i', [_vm._v("January 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary10"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0015-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("May your whole spirit, soul, and body be preserved blameless at the coming of our Lord Jesus Christ")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("C")]), _vm._v("hrist . . . loved the church and gave Himself for her, . . . that He might present her to Himself a glorious church, not having spot or wrinkle or any such thing, but that she should be holy and without blemish. • Him we preach, warning every man and teaching every man in all wisdom, that we may present every man perfect in Christ Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-7"
    }
  }, [_vm._v("The peace of God . . . surpasses all understanding. • Let the peace of God rule in your hearts, to which also you were called in one body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-8"
    }
  }, [_vm._v("May our Lord Jesus Christ Himself, and our God and Father, who has loved us and given us everlasting consolation and good hope by grace, comfort your hearts and establish you in every good word and work. • [God] will also confirm you to the end, that you may be blameless in the day of our Lord Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("1 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESS")]), _vm._v(". 5:23; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 5:25, 27; C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OL")]), _vm._v(". 1:28; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 4:7; C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OL")]), _vm._v(". 3:15; 2 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESS")]), _vm._v(". 2:16–17; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 1:8")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary10"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0015-08-12"
    }
  }, [_c('span', [_c('i', [_vm._v("Will God indeed dwell with men on the earth?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-09-14"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("L")]), _vm._v("et them make Me a sanctuary, that I may dwell among them. • I will meet with the children of Israel, and the tabernacle shall be sanctified by My glory. . . . I will dwell among the children of Israel and will be their God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-10-17"
    }
  }, [_vm._v("You have ascended on high, You have led captivity captive; You have received gifts among men, even from the rebellious, that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God might dwell there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-10-18"
    }
  }, [_vm._v("You are the temple of the living God. As God has said: “I will dwell in them and walk among them. I will be their God, and they shall be My people.” • Your body is the temple of the Holy Spirit who is in you, whom you have from God. • You also are being built together for a dwelling place of God in the Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-10-19"
    }
  }, [_vm._v("The nations also will know that I, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", sanctify Israel, when My sanctuary is in their midst forevermore.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRON")]), _vm._v(". 6:18; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("X")]), _vm._v(". 25:8; 29:43, 45; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 68:18; 2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 6:16; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 6:19; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 2:22; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ZEK")]), _vm._v(". 37:28")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b74940ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter12.vue
// module id = 99
// module chunks = 0